<div class="drop-datepicker-dialog">
  <div class="drop-datepicker-dialog-header flex-between-center">
    <p class="m-0 font-bold">Select custom dates</p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="closeModal()"></i>
    </span>
  </div>

  <div class="drop-datepicker-dialog-body flex-start-start">
    <div class="start-date-section flex-column" *ngIf="!isEndDatePickerOnly">
      <p class="pl-4p mb-1 font-gray-55 font-bold">Start date</p>
      <div class="date-picker">
        <p-calendar dateFormat="mm/dd/yy" [inline]="true" [maxDate]="maxStartDateRange" [(ngModel)]="startDate"
          (onSelect)="handleStartDateChange($event)"></p-calendar>
      </div>
    </div>
    <div class="end-date-section flex-column">
      <p class="pl-4p mb-1 font-gray-55 font-bold"> {{endDateTitle}} </p>
      <div class="date-picker">
        <p-calendar [dateFormat]="dateFormat" [view]="viewMode" [inline]="true" [minDate]="!isEndDatePickerOnly ? startDate : false"
          [maxDate]="maxEndDateRange" [(ngModel)]="endDate" (onSelect)="handleEndDateChange($event)"></p-calendar>
      </div>
    </div>
  </div>

  <span *ngIf="id === 'technician-attendance-log'" class="date-range-alert font-gray-55">*Please note that the start and
    end date cannot be more than 31 days apart</span>
</div>
